import { Html } from '@react-three/drei'
import { useRef, useState } from 'react'
import { Group, Object3D } from 'three'
import { useSceneStore } from '../../../a.scenes/GameScene/store'
import { useScenesStore } from '../../../b.providers/ScenesProvider/store'
import { SEL_BATTLE_STATE } from '../../../c.managers/LevelManager/selectors'
import { BATTLE_STATES, COMMANDERS } from '../../../c.managers/LevelManager/store.d'
import { TreasureConfig } from '../../../f.assets/Characters/scripts/classes/TreasureConfig'
import { CHARACTER_TYPES } from '../../../f.assets/Characters/scripts/constants'
import Treasure from '../classes/Treasure'
import GameElement, { GameElementType } from '../GameElement/GameElement'

const GameTreasure = (props: GameElementType) => {
  const { children, ...moreProps } = props
  const [uuid, setUUID] = useState<string>()
  const IndicatorRef = useRef<Group>(null)
  const battleState = useSceneStore(SEL_BATTLE_STATE)
  const battleIsActive = battleState === BATTLE_STATES.ONGOING

  return (
    <>
      <group ref={IndicatorRef}>{uuid && battleIsActive && <InfoComponent owner={props.userData!.args.owner} />}</group>
      <GameElement
        onUpdate={obj => IndicatorRef.current?.position.copy(obj.position)}
        elementClass={Treasure}
        {...moreProps}
        addedToScene={(obj: Object3D) => {
          if (props?.addedToScene) {
            props?.addedToScene(obj)
          }
          setUUID(obj.uuid)
        }}
      >
        {children}
      </GameElement>
    </>
  )
}

export default GameTreasure

const InfoComponent = ({ owner }: { owner: COMMANDERS }) => {
  const treasureState = useSceneStore(s => s.terrain.data.treasures.find(t => t.owner === owner)) as TreasureConfig
  const players = useSceneStore(s => s.levels.data.players)
  const homeTeam = useScenesStore(s => s.user.team)
  const awayTeam = homeTeam === CHARACTER_TYPES.JACK ? CHARACTER_TYPES.WITCH : CHARACTER_TYPES.JACK
  const treasureTeam = treasureState.owner === COMMANDERS.PLAYER ? homeTeam : awayTeam
  const color = treasureTeam === CHARACTER_TYPES.JACK ? '#ff7c5b' : '#ac3cef'
  const bgcolor = treasureTeam === CHARACTER_TYPES.JACK ? '#a12808' : '#3d1156'
  return (
    <Html
      position={[0, 2.5, 0]}
      style={{
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 90,
        transform: 'translate(-50%, 0)',
      }}
    >
      <HPBar
        progress={Math.round((treasureState.amount! / treasureState.amount_max!) * 100)}
        color={color}
        bgcolor={bgcolor}
      />
    </Html>
  )
}

const HPBar = ({
  progress = 50,
  color = 'gray',
  bgcolor = 'white',
}: {
  progress?: number
  color?: string
  bgcolor?: string
}) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '0.4rem',
      width: '30px',
      border: '1px solid black',
      borderRadius: '2rem',
      backgroundColor: bgcolor,
    }}
  >
    <div
      style={{
        width: '100%',
        height: '100%',
        borderRadius: '2rem',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.5s',
        willChange: 'transform',
        boxShadow: `0 0 5px ${color}`,
      }}
    >
      <div
        style={{
          position: 'absolute',
          height: '100%',
          width: `${progress}%`,
          content: '',
          backgroundColor: color,
          top: 0,
          bottom: 0,
          left: 0,
          borderRadius: 'inherit',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      ></div>
    </div>
  </div>
)
